// Preferência manual de onde as buscas (produtos, parceiros, plano de
// contas, operações...) devem ir buscar dado — sobrepõe a detecção
// automática de conexão (ver conexao.ts) quando o usuário força um lado.
// Consultado pelo comOffline (ver servico.ts), que é o que toda tela de
// busca já usa — não precisa mexer em cada service pra isso valer.
//
// - 'automatico' (padrão): tenta o servidor; se a conexão cair, cai pro
//   local sozinho (e volta pro servidor quando a conexão volta).
// - 'online': força sempre o servidor, mesmo que a conexão caia no meio —
//   não cai pro local sozinho (pra quem quer garantir dado sempre atualizado
//   e prefere ver o erro a vender com estoque desatualizado, por exemplo).
// - 'offline': força sempre a cópia local, mesmo com internet disponível
//   (pra quem quer economizar/evitar uma conexão lenta ou instável).
//
// Guardado no localStorage (não no IndexedDB kv) porque é uma preferência de
// interface, lida de forma síncrona pelo comOffline a cada busca — não é
// dado sincronizado com o servidor.

export type TModoBusca = 'automatico' | 'online' | 'offline';

const CHAVE = 'SIAC_MODO_BUSCA';

const lerInicial = (): TModoBusca => {
  try {
    const valor = localStorage.getItem(CHAVE);
    if (valor === 'automatico' || valor === 'online' || valor === 'offline') return valor;
  } catch {
    // localStorage indisponível (raro) — segue no padrão.
  }
  return 'automatico';
};

let modo: TModoBusca = lerInicial();
const ouvintes = new Set<(modo: TModoBusca) => void>();

export const modoBuscaAtual = (): TModoBusca => modo;

export const definirModoBusca = (novo: TModoBusca): void => {
  if (novo === modo) return;
  modo = novo;
  try {
    localStorage.setItem(CHAVE, novo);
  } catch {
    // Preferência é best-effort — não trava a troca de modo por causa disso.
  }
  ouvintes.forEach((ouvinte) => ouvinte(modo));
};

export const inscreverModoBusca = (ouvinte: (modo: TModoBusca) => void): (() => void) => {
  ouvintes.add(ouvinte);
  return () => { ouvintes.delete(ouvinte); };
};
